<template>
  <div class="card">
    <header class="bandeau-modal card-header">
    </header>
    <div class="card-content">
      <div class="pd-20px">
          <p
            class="has-text-link is-size-3 has-text-weight-bold mgb-20px has-text-centered">
            {{ $t('popupAffectation.title', {code: produit.reference})}}
          </p>
        <v-client-table :data="produit.affectations"
                      :show-pagination="false"
                      :columns="columns"
                      :options="options"
                      ref="tableInfoEcheance">
          <div slot="type" slot-scope="props">
            {{$t('popupAffectation.type.'+ props.row.typeReference.toLowerCase())}}
          </div>
          <div slot="dates" slot-scope="props">
            <span v-if="props.row.dureeAffectation.dateFin">
              {{$t('popupAffectation.datePeriode',
                { dateDebut: props.row.dureeAffectation.dateDebut,
                dateFin: props.row.dureeAffectation.dateFin})}}
            </span>
            <span v-else>
              {{$t('popupAffectation.periodeInfini',
                { dateDebut: props.row.dureeAffectation.dateDebut })}}
            </span>
          </div>
          <div slot="libelle" slot-scope="props">
            <router-link-blank :to="{
              name: getRouteName(props.row),
              params: getParams(props.row) ,
              }"
                               :message="props.row.libelle">
            </router-link-blank>
          </div>
        </v-client-table>
        <div class="is-grouped pdt-20px">
          <button
            class="button btn-modal-annuler is-cancel pdh-20px"
            @click="$parent.close">
            {{$t('popupAffectation.actions.close')}}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import { TEXTS, SORT_ICON } from '@/configuration/clientTableConf';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import { AFFECTATION_RESEAU } from '@/configuration/catalogue/produitConf';

const Societe = createNamespacedHelpers('societe');

export default {
  props: {
    produit: Object,
  },
  components: {
    routerLinkBlank,
  },
  computed: {
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    columns() {
      return ['type', 'libelle', 'dates'];
    },
    options() {
      const texts = cloneDeep(TEXTS);
      texts.count = '';
      return {
        sortIcon: SORT_ICON,
        headings: {
          type: this.$i18n.t('popupAffectation.table.type'),
          libelle: this.$i18n.t('popupAffectation.table.libelle'),
          dates: this.$i18n.t('popupAffectation.table.dates'),
        },
        sortable: ['type', 'libelle', 'dates'],
        texts: texts,
        filterable: false,
        columnsClasses: {
          libelle: 'ellipsis width-250',
        },
      };
    },
  },
  methods: {
    getParams(affectation) {
      return affectation.typeReference === AFFECTATION_RESEAU
        || !affectation.commandeInterne
        || (affectation.commandeInterne
          && affectation.commandeInterne.societeId !== this.societeActiveId)
        ? { id: affectation.referenceId } : { id: affectation.commandeInterne.id };
    },
    getRouteName(affectation) {
      if (affectation.typeReference === AFFECTATION_RESEAU) {
        return 'c.bodac.catalogue-reseau';
      }
      if (affectation.commandeInterne
        && affectation.commandeInterne.societeId === this.societeActiveId) {
        return 'c.bodac.commandes-venteInterne';
      }
      return 'c.bodac.commandes';
    },
  },
};
</script>
